<div class="lv-artefact-container lv-component">
  <span *ngIf="!!uiArtefakt.Text" [innerHTML]="uiArtefakt.Text + '&nbsp;'"></span>
  <mat-icon fontSet="fal" [svgIcon]="'InfoCircle'" class="lv-info-icon" (click)="openModalDialog()"></mat-icon>
</div>
